<template>
  <!-- flow-root contains the mt-[100dvh] margin below: without a BFC here it -->
  <!-- collapses through the layout wrappers (overflow-x-clip doesn't block it, -->
  <!-- unlike the old overflow-x-hidden) and shifts the entire off-white page -->
  <!-- background down a full viewport, leaving white behind the hero. -->
  <div class="flow-root">
    <div class="fixed top-0 left-0 w-full min-h-dvh pt-18 md:pt-26 flex justify-center items-center z-20">
      <slot name="hero" />
    </div>
    <div class="bg-background relative z-40 mt-[100dvh]">
      <slot />
    </div>
  </div>
</template>
